import CardTemp from './CardTemplate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faParking } from '@fortawesome/free-solid-svg-icons';
library.add(faParking);

function MethodistTabContent() {
  return (
    <div className="row container">
      <CardTemp
        cardLink="/MethodistAnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./Parking Symbol1.jpg')}
        imgTitle=" Methodist Parking Information"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Locations:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>2</span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            24 Hours 7 Days
          </span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Waiting List:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Yes</span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Wait for Parking:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>18 Months+</span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Storage:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>No Storage</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Licenses:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Public</span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Office Tel:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (718) 369-8185
          </span>
          <br />
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            {' '}
            Email:{' '}
            <a href="mailto:parkingnyp-BMH@nyp.org">parkingnyp-BMH@nyp.org</a>
          </span>
        </span>
      />
      <CardTemp
        cardLink="/SixStAnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./6th Street.jpg')}
        imgTitle=" Six Street (Wesley House) Garage"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            501 6th Street Brooklyn NY 11215
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Garage</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            24 Hours 7 Days
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Valet/Self-Park
          </span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>550 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Public</span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (718) 369-8185 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            <a href="mailto:nypparking-BMH@nyp.org">nypparking-BMH@nyp.org</a>
          </span>
        </span>
      />
      <CardTemp
        cardLink="/CCHAnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./CCH.jpg')}
        imgTitle=" Center of Community Health (CCH) Garage"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            515 6th Street Brooklyn NY 11215
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Garage</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            24 Hours 7 Days Accessible
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Valet Only</span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>320 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Public</span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (929) 470-9101 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            <a href="mailto:nypparking-BMH@nyp.org">nypparking-BMH@nyp.org</a>
          </span>
        </span>
      />
    </div>
  );
}
export default MethodistTabContent;
